import React from "react";
import { Link } from "react-router-dom";
import { TbGridDots } from "react-icons/tb";
import "../../styles/ListingDetails.scss";
import { Button } from "@nextui-org/react";

function ListingImageGallery({ listing }) {
  const signedUrls = listing?.signedUrls || [];

  if (!listing) {
    return <div>Loading...</div>;
  }

  const seeMoreButton = signedUrls.length > 5;

  return (
    <div>
      {/* Listing images index[0] is the main */}
      <div className="listing-photos d-flex flex-row">
        {/* Main photo */}
        <div className="main-photo p-2">
          <a href={`/listings/gallery/${listing._id}`} target="_blank">
            <img
              key={signedUrls[0]}
              src={signedUrls[0]}
              alt=""
              className="listing-photo"
            />
          </a>
          <span className=""></span>
        </div>

        {/* Other Photo */}
        <div className="other-photos border-0 p-2">
          {signedUrls.slice(1, 5).map((url, index) => (
            <a href={`/listings/gallery/${listing._id}`} target="_blank">
              <img
                key={url}
                src={url}
                alt=""
                className="listing-photo other-photo"
              />
            </a>
          ))}
        </div>
      </div>
      {seeMoreButton && (
        <div className="relative flex justify-end items-start mt-2 mb-2">
          <a href={`/listings/gallery/${listing._id}`} target="_blank">
            <Button color="danger">See more images</Button>
          </a>
        </div>
      )}
    </div>
  );
}

export default ListingImageGallery;
